"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseEntitiesService_1 = require("./BaseEntitiesService");
var singleton_1 = require("../singleton");
var adm_repositories_1 = require("../repositories/adm-repositories");
//
// adm.users
//
var UsersService = /** @class */ (function (_super) {
    __extends(UsersService, _super);
    function UsersService() {
        return _super.call(this, new adm_repositories_1.UsersRepository()) || this;
    }
    UsersService.getInstance = singleton_1.createSingleton(function () { return new UsersService(); }, '__usersService');
    return UsersService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.UsersService = UsersService;
//
// adm.datasets
//
var DatasetsService = /** @class */ (function (_super) {
    __extends(DatasetsService, _super);
    function DatasetsService() {
        return _super.call(this, new adm_repositories_1.DatasetsRepository()) || this;
    }
    DatasetsService.getInstance = singleton_1.createSingleton(function () { return new DatasetsService(); }, '__datasetsService');
    return DatasetsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.DatasetsService = DatasetsService;
//
// adm.topics
//
var TopicsService = /** @class */ (function (_super) {
    __extends(TopicsService, _super);
    function TopicsService() {
        return _super.call(this, new adm_repositories_1.TopicsRepository()) || this;
    }
    TopicsService.getInstance = singleton_1.createSingleton(function () { return new TopicsService(); }, '__topicsService');
    return TopicsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.TopicsService = TopicsService;
//
// adm.topic_dataset_maps
//
var TopicDatasetMapsService = /** @class */ (function (_super) {
    __extends(TopicDatasetMapsService, _super);
    function TopicDatasetMapsService() {
        return _super.call(this, new adm_repositories_1.TopicDatasetMapsRepository()) || this;
    }
    TopicDatasetMapsService.getInstance = singleton_1.createSingleton(function () { return new TopicDatasetMapsService(); }, '__topicDatasetMapsService');
    return TopicDatasetMapsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.TopicDatasetMapsService = TopicDatasetMapsService;
//
// adm.user_groups
//
var UserGroupsService = /** @class */ (function (_super) {
    __extends(UserGroupsService, _super);
    function UserGroupsService() {
        return _super.call(this, new adm_repositories_1.UserGroupsRepository()) || this;
    }
    UserGroupsService.getInstance = singleton_1.createSingleton(function () { return new UserGroupsService(); }, '__userGroupsService');
    return UserGroupsService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.UserGroupsService = UserGroupsService;
//
// adm._data_sources
//
var DataSourcesService = /** @class */ (function (_super) {
    __extends(DataSourcesService, _super);
    function DataSourcesService() {
        return _super.call(this, new adm_repositories_1.DataSourceRepository()) || this;
    }
    DataSourcesService.getInstance = singleton_1.createSingleton(function () { return new DataSourcesService(); }, '__dataSourcesService');
    return DataSourcesService;
}(BaseEntitiesService_1.BaseEntitiesService));
exports.DataSourcesService = DataSourcesService;
